interface CustomPrismicInjecterArgs {
  [key: string]: string;
}
/**
 * This component is an html serializer allowing to inject a variable inside Prismic RichText
 *
 * @param {CustomPrismicInjecterArgs} { searchValue, replacement }
 */
export const PrismicRichTextInjecter =
  (injections: CustomPrismicInjecterArgs) =>
  (type: string, _element: any, text: string, children: any, index: number) => {
    const injectionRegex = new RegExp(Object.keys(injections).join('|'), 'g');
    const content = text
      ? text.replace(injectionRegex, (value) => injections[value])
      : children;

    switch (type) {
      case 'strong':
        return <strong key={index}>{content}</strong>;
      case 'span':
        return <span key={index}>{content}</span>;
      case 'paragraph':
        return <p key={index}>{content}</p>;
      default:
        return null;
    }
  };
